import React, { useContext } from "react";

import { LanguageContext } from "../LanguageContext"; // Import the LanguageContext
import SEO from "../components/SEO";
const Terms = () => {
  const { language } = useContext(LanguageContext); // Get the current language

const metaTitle = "Terms and Conditions - Snapseed QR Codes | Website Policies";
const metaDescription = "Read the terms and conditions for using Snapseedqrcodes.download. By using our website, you agree to these rules.";
const metaUrl = "https://www.snapseedqrcodes.download/terms";
const metaImage = "https://www.snapseedqrcodes.download/snapseedqrcodes_logo.webp";

// ✅ **Schema Markup for Google SEO**
const schemaMarkup = {
  "@context": "https://schema.org",
  "@type": "TermsOfService",
  "headline": metaTitle,
  "description": metaDescription,
  "url": metaUrl,
  "image": metaImage,
  "publisher": {
    "@type": "Organization",
    "name": "Snapseed QR Codes",
    "logo": metaImage
  }
};

  return (
    <div>
     {/* Use the SEO Component */}
     <SEO
        title={metaTitle}
        description={metaDescription}
        url={metaUrl}
        image={metaImage}
        schemaMarkup={schemaMarkup}
        canonicalUrl={metaUrl}
      />

      <section className="snapseed">
        <h1>{language === "english" ? "Terms and Conditions" : "नियम और शर्तें"}</h1>
        <p>
          {language === "english"
            ? "Welcome to snapseedqrcodes.download! By using our website, you agree to follow these rules. Please read them carefully before using our site."
            : "स्वागत है snapseedqrcodes.download पर! हमारी वेबसाइट का उपयोग करके, आप इन नियमों का पालन करने के लिए सहमत होते हैं। कृपया हमारी साइट का उपयोग करने से पहले उन्हें ध्यान से पढ़ें।"}
        </p>

        <h1>
          {language === "english"
            ? "1. Accepting These Terms"
            : "1. इन शर्तों को स्वीकार करना"}
        </h1>
        <p>
          {language === "english"
            ? "When you use snapseedqrcodes.download, you agree to:"
            : "जब आप snapseedqrcodes.download का उपयोग करते हैं, तो आप सहमत होते हैं:"}
          <ul>
            <li>
              {language === "english"
                ? "Comply with all these rules and conditions"
                : "इन सभी नियमों और शर्तों का पालन करने के लिए"}
            </li>
            <li>
              {language === "english"
                ? "Accept our privacy policy"
                : "हमारी गोपनीयता नीति को स्वीकार करने के लिए"}
            </li>
            <li>
              {language === "english"
                ? "Follow any other rules we may add for specific features"
                : "किसी भी अन्य नियमों का पालन करने के लिए जो हम विशेष सुविधाओं के लिए जोड़ सकते हैं"}
            </li>
          </ul>
        </p>

        <h1>{language === "english" ? "Using Our Website" : "हमारी वेबसाइट का उपयोग करना"}</h1>
        <p>
          {language === "english"
            ? "We want to help you use QR codes safely. Here’s what you need to know:"
            : "हम आपको QR कोड का सुरक्षित रूप से उपयोग करने में मदद करना चाहते हैं। यहाँ जो आपको जानने की आवश्यकता है:"}
          <ul>
            <li>
              {language === "english"
                ? "Our QR codes are for personal use only"
                : "हमारे QR कोड केवल व्यक्तिगत उपयोग के लिए हैं"}
            </li>
            <li>
              {language === "english"
                ? "You may not use them for any illegal activities"
                : "आप उनका उपयोग किसी भी अवैध कार्य के लिए नहीं कर सकते"}
            </li>
            <li>
              {language === "english"
                ? "The information we provide is intended to be helpful but may not be perfect"
                : "हम जो जानकारी प्रदान करते हैं वह मददगार होने का इरादा है लेकिन परिपूर्ण नहीं हो सकती"}
            </li>
          </ul>
        </p>

        <h1>{language === "english" ? "Links to Other Websites" : "अन्य वेबसाइटों के लिंक"}</h1>
        <p>
          {language === "english"
            ? "Sometimes we provide links to other websites. Please note:"
            : "कभी-कभी हम अन्य वेबसाइटों के लिंक प्रदान करते हैं। कृपया ध्यान दें:"}
          <ul>
            <li>
              {language === "english"
                ? "We do not control these other websites"
                : "हम इन अन्य वेबसाइटों को नियंत्रित नहीं करते हैं"}
            </li>
            <li>
              {language === "english"
                ? "We are not responsible for their content"
                : "हम उन पर जो कुछ भी है उसके लिए जिम्मेदार नहीं हैं"}
            </li>
            <li>
              {language === "english"
                ? "You visit them at your own risk"
                : "आप उन्हें अपने जोखिम पर देखते हैं"}
            </li>
          </ul>
        </p>

        <h1>{language === "english" ? "Our Responsibility" : "हमारी जिम्मेदारी"}</h1>
        <p>
          {language === "english"
            ? "We work hard to provide good service, but:"
            : "हम अच्छी सेवा प्रदान करने के लिए कड़ी मेहनत करते हैं, लेकिन:"}
          <ul>
            <li>
              {language === "english"
                ? "We offer our content 'as is'"
                : "हम अपनी सामग्री 'जैसी है' प्रदान करते हैं"}
            </li>
            <li>
              {language === "english"
                ? "We cannot guarantee that everything is 100% accurate"
                : "हम गारंटी नहीं दे सकते कि सब कुछ 100% सटीक होगा"}
            </li>
            <li>
              {language === "english"
                ? "We are not responsible for any problems that may occur while using our site"
                : "हमारी साइट का उपयोग करते समय हो सकने वाली किसी भी समस्या के लिए हम जिम्मेदार नहीं हैं"}
            </li>
          </ul>
        </p>

        <h1>{language === "english" ? "Your Content Rights" : "आपके सामग्री अधिकार"}</h1>
        <p>
          {language === "english"
            ? "When you create or share content on our site:"
            : "जब आप हमारी साइट पर सामग्री बनाते हैं या साझा करते हैं:"}
          <ul>
            <li>
              {language === "english"
                ? "You give us permission to use anything you share"
                : "आप हमें आपके द्वारा साझा की गई किसी भी चीज का उपयोग करने की अनुमति देते हैं"}
            </li>
            <li>
              {language === "english"
                ? "We can use it globally without paying you"
                : "हम इसे बिना आपको भुगतान किए विश्वव्यापी उपयोग कर सकते हैं"}
            </li>
            <li>
              {language === "english"
                ? "We may allow others to use it as well"
                : "हम इसे दूसरों को भी उपयोग करने दे सकते हैं"}
            </li>
          </ul>
        </p>

        <h1>{language === "english" ? "Changes to These Terms" : "इन शर्तों में परिवर्तन"}</h1>
        <p>
          {language === "english"
            ? "We may update these terms from time to time. If we do:"
            : "कभी-कभी हम इन शर्तों को अपडेट कर सकते हैं। अगर हम करते हैं:"}
          <ul>
            <li>
              {language === "english"
                ? "We will post the new version here"
                : "हम यहाँ नया संस्करण पोस्ट करेंगे"}
            </li>
            <li>
              {language === "english"
                ? "Your continued use means you accept the changes"
                : "आपका निरंतर उपयोग मतलब है कि आप परिवर्तनों को स्वीकार करते हैं"}
            </li>
          </ul>
        </p>

        <h1>{language === "english" ? "Contact Us" : "संपर्क करें"}</h1>
        <p>
          {language === "english"
            ? "If you have any questions about these terms, please contact us: snapseedqrcodes.download@gmail.com"
            : "अगर इन शर्तों के बारे में आपके कोई प्रश्न हैं, तो कृपया हमसे संपर्क करें: snapseedqrcodes.download@gmail.com"}
        </p>
      </section>
    </div>
  );
};

export default Terms;
